// Based on the Rolex JS subnav script
// TODO: Are we doing breadcrumbs?

import '../css/tudor.less';

import { scrollIntoView } from 'seamless-scroll-polyfill';
import {
  disableBodyScroll,
  clearAllBodyScrollLocks,
} from 'body-scroll-lock-upgrade';

document.addEventListener('DOMContentLoaded', async () => {
  const nav = document.querySelector('.js-tudor-nav') as HTMLElement;
  const navToggle = document.querySelector('.js-toggle-tudor-nav') as HTMLButtonElement;
  const navDropdown = document.querySelector('.js-tudor-nav-dropdown') as HTMLElement;

  // The private editorial theme supplies its own accessible navigation.
  if (!nav || !navToggle || !navDropdown) return;

  navToggle.addEventListener('click', (e) => {
    e.preventDefault();

    if (navDropdown.classList.contains('open')) {
      navToggle.classList.remove('open');
      navDropdown.classList.remove('open');
      navDropdown.setAttribute('aria-hidden', 'true');
      clearAllBodyScrollLocks();
    } else {
      scrollIntoView(nav, { behavior: 'smooth' });
      navToggle.classList.add('open');
      navDropdown.classList.add('open');
      navDropdown.removeAttribute('aria-hidden');
      disableBodyScroll(navDropdown);
    }
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth > 1649) {
      if (nav) {
        navToggle.classList.remove('open');
        navDropdown.classList.remove('open');
        navDropdown.removeAttribute('aria-hidden');
      }
    }
  });

  const navLinks = document.querySelectorAll<HTMLAnchorElement>('.tudor-header__nav-link');

  // Check breadcrumbs to see if it has a parent page. If there are only two that means its not a child page

  // Select all elements with the class 'tudor-breadcrumbs__link'
  // const breadcrumbLinks = document.querySelectorAll<HTMLAnchorElement>('.tudor-breadcrumbs__link');

  // Convert the NodeList to an array
  // const breadcrumbLinkArray = Array.from(breadcrumbLinks);

  // Ensure there is at least one element and remove the first element (ie remove the rolex landing page)
  // if (breadcrumbLinkArray.length !== 0) {
  //   breadcrumbLinkArray.shift();
  // }

  navLinks.forEach((link) => {
    // Manually set the active link on click. Needed for anchors that don't reload the page.
    link.addEventListener('click', () => {
      navLinks.forEach((l) => {
        const href = l.getAttribute('href');
        console.debug(href);
        l.classList.toggle('active', l === link);
      });
    });

    // (On page load) Check if the link's href matches the current URL or its parents
    if (link.href === document.URL) {
      link.classList.add('active');
      return;
    }
    // else if (breadcrumbLinkArray.length) {
    //   breadcrumbLinkArray.forEach((breadcrumb) => {
    //     if (link.href === breadcrumb.href) {
    //       link.classList.add('active');
    //       return;
    //     }
    //   });
    // }
  });
});
